import { RouterView } from "vue-router";
import { ProjectBoardRouting } from "./project-board/project-board.routing";

export const DataboardRouting = {
  path: "/data-board",
  name: "data-board",
  redirect: "/data-board/project-board/panel",
  component: RouterView,
  meta: { title: "数据看板", icon: "dashboard" },
  children: [...ProjectBoardRouting],
};
